/**
 * @author      Michael Hettmer <mail@michael-hettmer.de>
 * @copyright   2019 Plusbyte UG (haftungsbeschränkt)
 * @license     {@link https://plusbyte.de Plusbyte License}
 */

import React from 'react';

import Card, { CardValue } from '~/overlay/bar-bottom/Card';
import { cn } from '~/utils/styles';

interface CardRowProps {
  cards: CardValue[];
  isSelected: (card: { value: CardValue; index: number }) => boolean;
  onCardClicked: (card: { value: CardValue; index: number }) => void;
  onBonusCardClicked?: () => void;
  removedCards?: CardValue[];
  bonusCardsEnabled?: boolean;
  color: number;
  cardWidth: number;
}

const CardRow = ({
  cards,
  isSelected,
  onCardClicked,
  removedCards = [],
  bonusCardsEnabled = false,
  color,
  cardWidth,
  onBonusCardClicked,
}: CardRowProps): JSX.Element => (
  <>
    {cards.map((value, index) => (
      <Card
        key={index}
        value={value}
        color={color}
        className={cn(
          'transform-gpu cursor-pointer transition-all active:scale-95',
          isSelected({ value, index }) ? 'opacity-100' : 'opacity-30 hover:opacity-60',
        )}
        style={{ width: `${cardWidth}%` }}
        onClick={() => onCardClicked({ value, index })}
      />
    ))}
    {removedCards.length > 0 && (
      <div
        className="mx-2 flex flex-row items-center"
        style={{
          width: `${cardWidth * removedCards.length}%`,
        }}
      >
        {removedCards.map((card, index) => (
          <Card
            key={index}
            value={card}
            color={color}
            className="transform-gpu cursor-pointer opacity-30 transition-all hover:opacity-60 active:scale-95"
            removed
          />
        ))}
      </div>
    )}
    {bonusCardsEnabled && (
      <Card
        key={'bonus'}
        value={0}
        className="ml-4 transform-gpu cursor-pointer opacity-100 transition-all active:scale-95"
        color={color}
        onClick={onBonusCardClicked}
        style={{ width: `${cardWidth}%` }}
      />
    )}
  </>
);

export default CardRow;
